import { axiosInstance } from '@/Api/axiosV2Config';
import type { SavListFilters, SavListResponse } from '@/features/savs/types/sav.types';

export const savApi = {
  list: async (filters?: SavListFilters): Promise<SavListResponse> => {
    const { data } = await axiosInstance.get<SavListResponse>('/pro-v2/sav', {
      params: filters,
    });
    return data;
  },
};
